import { base64url } from './base64';

export function decodeJWT(token: string): unknown {
  const payload = token.split('.')[1];

  if (!payload) {
    throw new Error('Missing payload');
  }

  const buffer = base64url.decode(payload, { strict: false });
  const jwt = new TextDecoder().decode(buffer);
  return JSON.parse(jwt);
}
